import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useMediaQuery } from '../../hooks';
var ServiceContext = /*#__PURE__*/createContext(undefined);

var ThemeContextProvider = function ThemeContextProvider(_ref) {
  var children = _ref.children;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      componentVariants = _useState2[0],
      setUiTheme = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      appTheme = _useState4[0],
      setAppTheme = _useState4[1];

  var mediaQueryMatches = useMediaQuery();
  var getUiTheme = useCallback(function (themeId, defaultTheme) {
    return componentVariants[themeId] ? _extends({}, defaultTheme, componentVariants[themeId]) : defaultTheme;
  }, [componentVariants]);
  var getAppTheme = useCallback(function (themeId, defaultTheme) {
    return appTheme[themeId] ? _extends({}, defaultTheme, appTheme[themeId]) : defaultTheme;
  }, [appTheme]);
  return /*#__PURE__*/React.createElement(ServiceContext.Provider, {
    value: {
      getUiTheme: getUiTheme,
      getAppTheme: getAppTheme,
      setUiTheme: setUiTheme,
      setAppTheme: setAppTheme,
      appTheme: appTheme,
      mediaQueryMatches: mediaQueryMatches
    }
  }, children);
};

var useTheme = function useTheme() {
  var context = useContext(ServiceContext);

  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeContextProvider');
  }

  return context;
};
/**
 * Overrides component-specific styling and theming. See {@link UiTheme}.
 * @param themeId
 * @param defaultTheme
 * @returns
 */


var useUiTheme = function useUiTheme(themeId, defaultTheme) {
  var _useTheme = useTheme(),
      getUiTheme = _useTheme.getUiTheme;

  var _useState5 = useState(defaultTheme),
      _useState6 = _slicedToArray(_useState5, 2),
      orgTheme = _useState6[0],
      setOrgTheme = _useState6[1];

  useEffect(function () {
    var theme = getUiTheme(themeId, defaultTheme);
    setOrgTheme(theme);
  }, [defaultTheme, getUiTheme, themeId]);
  return orgTheme;
};

var useAppTheme = function useAppTheme(themeId, defaultTheme) {
  var _useTheme2 = useTheme(),
      getAppTheme = _useTheme2.getAppTheme;

  var _useState7 = useState(defaultTheme),
      _useState8 = _slicedToArray(_useState7, 2),
      orgTheme = _useState8[0],
      setOrgTheme = _useState8[1];

  useEffect(function () {
    var theme = getAppTheme(themeId, defaultTheme);
    setOrgTheme(theme);
  }, [defaultTheme, getAppTheme, themeId]);
  return orgTheme;
};

var useTranslation = function useTranslation() {
  var _useTheme3 = useTheme(),
      appTheme = _useTheme3.appTheme;

  if (typeof appTheme.translation === 'undefined') {
    return {};
  }

  return appTheme.translation;
};

export { useTheme, ThemeContextProvider, useUiTheme, useAppTheme, useTranslation };